
const equityList = [
    {
        id: 1,
        title: '学生. 职业兴趣探索测评',
        intro: '【专业测评】采用霍兰德兴趣理论，详尽分析你的兴趣点，明晰职业方向，聚焦相关职业。',
        url: '/entityCard/appraisal',
    },
    {
        id: 2,
        title: '学生. 热门课程权益随心享',
        intro: '【培训+证书】互联网营销、人工智能、大数据、软件工程师等课程，包含国家级证书。',
        url: '/entityCard/rightsChange',
    },
    {
        id: 3,
        title: '学生. 无忧就业助力服务',
        intro: '【实习就业】一对一精准推荐面试，学生实习就业有保障，薪资平均5000+。',
        url: '/entityCard/employmentPower',
    },
    {
        id: 4,
        title: '学生. 深度职业规划',
        intro: '【职业规划】专业的职业规划老师进行1V1深度分析、定制职业规划。',
        url: '/entityCard/careerPlanning',
    },
    {
        id: 5,
        title: '破茧2023. 网红孵化训练营',
        intro: '【网红打造】3天落地实操教学，教你系统掌握新媒体平台定位和运营策略，快速掌握变现能力。',
        url: '/entityCard/InternetCelebrityIncubation',
    },
    {
        id: 6,
        title: '6大音视频APP会员随心选',
        intro: '【娱乐必备】优酷、腾讯、爱奇艺、QQ音乐、喜马拉雅、网易云音乐等热门APP会员。',
        url: '/entityCard/exchangeMembers',
    }
];
const cardList = {
    rallyCard: {
        title: '燃梦集结卡',
        desc: '开通燃梦集结VIP卡，即可领取：职业测评、热门职业课程、无忧就业服务、1V1职业规划、3天网红孵化训练营、热门VIP会员等6大权益。'
    },
    futureCard: {
        title: '炫动未来卡',
        desc: '开通炫动未来VIP卡，即可领取：职业测评、热门职业课程、无忧就业服务、1V1职业规划、3天网红孵化训练营、热门VIP会员等6大权益。'
    }
}
const nums = {
    0: '零',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    10: '十',
}

const tagList = [
    '爆款',
    '热门',
    '畅销',
    '高阶',
    '高阶'
]



export {
    equityList,
    nums,
    cardList,
    tagList,
}